export type ViewMode = "user" | "admin";

const STORAGE_KEY = "jc.viewMode";

// Per-browser convenience only; admin rights are always checked by the server.
export function readStoredViewMode(): ViewMode {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "admin" ? "admin" : "user";
  } catch {
    return "user";
  }
}

export function storeViewMode(mode: ViewMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (error) {
    console.warn("Could not persist view mode", error);
  }
}
